import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/sources/")({
  staticData: {
    title: "apps.sources",
  },
  loader: () => redirect({ to: "/sources/home" }),
});
